import React from 'react';
import { cn } from '../../../../lib/utils';

/**
 * FormInput - Atomic component for form text inputs
 * @param {Object} props
 * @param {boolean} props.error - Whether the input has an error
 * @param {string} props.className - Additional CSS classes
 * @param {React.Ref} ref - Forwarded ref
 */
export const FormInput = React.forwardRef(({ error = false, variant = 'pill', className = '', ...props }, ref) => {
    const variants = {
        pill: 'rounded-full',
        box: 'rounded-md',
    };

    const baseClasses = 'w-full px-3 py-2 border bg-white shadow-sm text-base placeholder:text-[rgba(179,179,179,1)] focus:outline-none focus:ring-2';
    const errorClasses = error
        ? 'border-red-500 focus:ring-red-500'
        : 'border-[rgba(217,217,217,1)] focus:ring-red-400';

    return (
        <input
            ref={ref}
            className={cn(baseClasses, variants[variant] || variants.pill, errorClasses, className)}
            {...props}
        />
    );
});

FormInput.displayName = 'FormInput';

export default FormInput;
